import React from "react";
import { useParams } from "react-router-dom";
import Header from "../../Header/Header";
import LessonViewer from "../../lms-shared/LessonViewer/LessonViewer";
import classes from "./Lesson.module.css"
import Projects from "../Projects/Projects";
import ShareProjectBtn from "../../UI/ShareProjectBtn";

const Lesson = ({backUrl}) => {

    let { studyGroupId, lessonId } = useParams()

    return <>
        <Header></Header>
        <div className={classes.LessonWrap}>
            <LessonViewer backUrl={backUrl} ProjectsComm={Projects} studyGroupId={studyGroupId} lessonId={lessonId} shareBtn={ShareProjectBtn}></LessonViewer>
        </div>
    </>
}

export default Lesson;